import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { HttpRequest, HttpResponse } from "@smithy/protocol-http";
import { isServerError, isThrottlingError, isTransientError } from "@smithy/service-error-classification";
import { NoOpLogger } from "@smithy/smithy-client";
import { INVOCATION_ID_HEADER, REQUEST_HEADER } from "@smithy/util-retry";
import { v4 } from "uuid";
import { isStreamingPayload } from "./isStreamingPayload/isStreamingPayload";
import { asSdkError } from "./util";
export var retryMiddleware = function retryMiddleware(options) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var retryStrategy, maxAttempts, retryToken, lastError, attempts, totalRetryDelay, request, isRequest, _yield$next, response, output, _retryStrategy;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return options.retryStrategy();
              case 2:
                retryStrategy = _context2.sent;
                _context2.next = 5;
                return options.maxAttempts();
              case 5:
                maxAttempts = _context2.sent;
                if (!isRetryStrategyV2(retryStrategy)) {
                  _context2.next = 38;
                  break;
                }
                retryStrategy = retryStrategy;
                _context2.next = 10;
                return retryStrategy.acquireInitialRetryToken(context["partition_id"]);
              case 10:
                retryToken = _context2.sent;
                lastError = new Error();
                attempts = 0;
                totalRetryDelay = 0;
                request = args.request;
                isRequest = HttpRequest.isInstance(request);
                if (isRequest) {
                  request.headers[INVOCATION_ID_HEADER] = v4();
                }
              case 17:
                if (!true) {
                  _context2.next = 36;
                  break;
                }
                _context2.prev = 18;
                if (isRequest) {
                  request.headers[REQUEST_HEADER] = "attempt=".concat(attempts + 1, "; max=").concat(maxAttempts);
                }
                _context2.next = 22;
                return next(args);
              case 22:
                _yield$next = _context2.sent;
                response = _yield$next.response;
                output = _yield$next.output;
                retryStrategy.recordSuccess(retryToken);
                output.$metadata.attempts = attempts + 1;
                output.$metadata.totalRetryDelay = totalRetryDelay;
                return _context2.abrupt("return", {
                  response: response,
                  output: output
                });
              case 31:
                _context2.prev = 31;
                _context2.t0 = _context2["catch"](18);
                return _context2.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var retryErrorInfo, _ref2, delay;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          retryErrorInfo = getRetryErrorInfo(_context2.t0);
                          lastError = asSdkError(_context2.t0);
                          if (!(isRequest && isStreamingPayload(request))) {
                            _context.next = 5;
                            break;
                          }
                          (_ref2 = context.logger instanceof NoOpLogger ? console : context.logger) === null || _ref2 === void 0 ? void 0 : _ref2.warn("An error was encountered in a non-retryable streaming request.");
                          throw lastError;
                        case 5:
                          _context.prev = 5;
                          _context.next = 8;
                          return retryStrategy.refreshRetryTokenForRetry(retryToken, retryErrorInfo);
                        case 8:
                          retryToken = _context.sent;
                          _context.next = 17;
                          break;
                        case 11:
                          _context.prev = 11;
                          _context.t0 = _context["catch"](5);
                          if (!lastError.$metadata) {
                            lastError.$metadata = {};
                          }
                          lastError.$metadata.attempts = attempts + 1;
                          lastError.$metadata.totalRetryDelay = totalRetryDelay;
                          throw lastError;
                        case 17:
                          attempts = retryToken.getRetryCount();
                          delay = retryToken.getRetryDelay();
                          totalRetryDelay += delay;
                          _context.next = 22;
                          return new Promise(function (resolve) {
                            return setTimeout(resolve, delay);
                          });
                        case 22:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[5, 11]]);
                })(), "t1", 34);
              case 34:
                _context2.next = 17;
                break;
              case 36:
                _context2.next = 41;
                break;
              case 38:
                retryStrategy = retryStrategy;
                if ((_retryStrategy = retryStrategy) !== null && _retryStrategy !== void 0 && _retryStrategy.mode) context.userAgent = [].concat(_toConsumableArray(context.userAgent || []), [["cfg/retry-mode", retryStrategy.mode]]);
                return _context2.abrupt("return", retryStrategy.retry(next, args));
              case 41:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[18, 31]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};
var isRetryStrategyV2 = function isRetryStrategyV2(retryStrategy) {
  return typeof retryStrategy.acquireInitialRetryToken !== "undefined" && typeof retryStrategy.refreshRetryTokenForRetry !== "undefined" && typeof retryStrategy.recordSuccess !== "undefined";
};
var getRetryErrorInfo = function getRetryErrorInfo(error) {
  var errorInfo = {
    error: error,
    errorType: getRetryErrorType(error)
  };
  var retryAfterHint = getRetryAfterHint(error.$response);
  if (retryAfterHint) {
    errorInfo.retryAfterHint = retryAfterHint;
  }
  return errorInfo;
};
var getRetryErrorType = function getRetryErrorType(error) {
  if (isThrottlingError(error)) return "THROTTLING";
  if (isTransientError(error)) return "TRANSIENT";
  if (isServerError(error)) return "SERVER_ERROR";
  return "CLIENT_ERROR";
};
export var retryMiddlewareOptions = {
  name: "retryMiddleware",
  tags: ["RETRY"],
  step: "finalizeRequest",
  priority: "high",
  override: true
};
export var getRetryPlugin = function getRetryPlugin(options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
    }
  };
};
export var getRetryAfterHint = function getRetryAfterHint(response) {
  if (!HttpResponse.isInstance(response)) return;
  var retryAfterHeaderName = Object.keys(response.headers).find(function (key) {
    return key.toLowerCase() === "retry-after";
  });
  if (!retryAfterHeaderName) return;
  var retryAfter = response.headers[retryAfterHeaderName];
  var retryAfterSeconds = Number(retryAfter);
  if (!Number.isNaN(retryAfterSeconds)) return new Date(retryAfterSeconds * 1000);
  var retryAfterDate = new Date(retryAfter);
  return retryAfterDate;
};